export const pluralize = (value: number, singular: string, plural: string): string => {
	return value === 1 ? singular : plural
}

export const resolveCycleStatus = (status: string): string => {
	if (!status) return status
	return status
		.split('-')
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
		.join(' ')
}
